<template>
  <div class='group-container'>
    <!-- <span>{{errMsg}}</span> -->
    <div class="image-wrapper">
      <img src="../../assets/img/img_ghc_home.png" alt="" />
    </div>
    <div class="footer-wrapper">
      <button @click="toRegister" class="footer-btn-shop">开通终端店铺账号</button>
      <button @click="toReseller" class="footer-btn-reseller">开通经销商账号</button>
    </div>
  </div>
</template>

<script>

import Vue from 'vue'
// import store from '../../store'
import { Toast } from 'vant'
Vue.use(Toast)

export default {
  name: 'Group',
  data() {
    return {
      errMsg: '箱标扫码结果'
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
    toRegister() {
      this.$router.replace({ name: 'ShopRegister' })
    },
    toReseller() {
      this.$router.replace({ name: 'ResellerRegister' })
    }
  }
}
</script>

<style lang="scss" scoped>
.group-container {
  margin: 0;
  text-align: center;
  height: 100%;
  span {
    width: 300px;
    font-size: 16px;
    color: #4a4a4a;
    font-weight: 600;
    display: block;
    margin:0 auto;
  }
  p {
    color: #747474;
    font-size: 14px;
    font-weight: 400;
  }
  button {
    margin-top: 24px;
    width: 120px;
    height: 30px;
    border-radius: 15px;
    background-color: #5e5ef6;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    border: none;
  }
  .image-wrapper {
    width: 375px;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .footer-wrapper {
    position: fixed;
    bottom: 0;
    z-index: 10;
    width: 375px;
    height: 68px;
    background: #fff;
    .footer-btn-shop {
      width: 210px;
      height: 46px;
      margin: 13px 0px 13px 10px;
      background: #1E81FF;
      color: #fff;
      font-size: 14px;
      border: none;
      border-radius: 5px;
    }
    .footer-btn-reseller {
      width: 128px;
      height: 46px;
      margin: 13px 10px 13px 10px;
      color: #1E81FF;
      background: #fff;
      font-size: 14px;
      border: 1px solid #1E81FF;
      border-radius: 5px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/qrcode/group.vue